import React, { type ComponentType } from 'react';

interface TipTapEditorProps {
  content: string;
  onChange?: (content: string) => void;
  onSave?: (content: string) => void;
  placeholder?: string;
  editable?: boolean;
  autoSaveDelay?: number;
  className?: string;
}

// Lazy load the TipTapEditor component
// This creates a code-split chunk that will only be loaded when the editor is actually used
export const TipTapEditorLazy: ComponentType<TipTapEditorProps> = React.lazy(() =>
  import('./TipTapEditor').then((module) => ({ default: module.TipTapEditor }))
);
